import { Button, Modal } from 'antd';
import styled from 'styled-components';

import { orbitTokens } from '../../styles';
import { pageType } from './pageStyles';

/**
 * Figma 6583:10012 draws the popup 246 wide with 12 / 8 / 9 px type and 14 px buttons (r6), and
 * places it nowhere. Until scale and placement are decided it is a centred modal at the page's
 * dialog scale (the context drawer's 38 px buttons, 13-14 px labels); every size lives here.
 */
export const POPUP_SCALE = {
  width: 400,
  inset: 20,
  bottomInset: 16,
  titleType: pageType.containerTitle,
  bodyType: pageType.containerBody,
  bodyGap: 6,
  buttonsGap: 20,
  buttonGap: 8,
  buttonHeight: 38,
  buttonPadding: 18,
  buttonRadius: 9,
  buttonType: pageType.conflictBody
};

// Literal colours, as the popup renders outside the page.
export const Popup = styled(Modal)`
  && .ant-modal-content {
    border-radius: 8px;
    background: #15203e;
    box-shadow: 0 10px 34px rgba(0, 0, 0, 0.5);
    font-family: ${orbitTokens.fontFamily};
  }

  && .ant-modal-header {
    padding: ${POPUP_SCALE.inset}px ${POPUP_SCALE.inset}px 0;
    border-bottom: none;
    background: transparent;
  }

  && .ant-modal-title {
    color: #aebbd0;
    font-weight: 400;
    ${POPUP_SCALE.titleType}
  }

  && .ant-modal-body {
    padding: ${POPUP_SCALE.bodyGap}px ${POPUP_SCALE.inset}px 0;
    color: #aebbd0;
    ${POPUP_SCALE.bodyType}
  }

  && .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: ${POPUP_SCALE.buttonsGap}px ${POPUP_SCALE.inset}px ${POPUP_SCALE.bottomInset}px;
    border-top: none;
  }

  && .ant-modal-footer .ant-btn + .ant-btn {
    margin-left: ${POPUP_SCALE.buttonGap}px;
  }
`;

export const PopupLine = styled.p`
  margin: 0;
`;

export const PopupError = styled.p`
  margin: 12px 0 0;
  color: #ee6475;
`;

const PopupButton = styled(Button)`
  && {
    height: ${POPUP_SCALE.buttonHeight}px;
    padding: 0 ${POPUP_SCALE.buttonPadding}px;
    border-radius: ${POPUP_SCALE.buttonRadius}px;
    box-shadow: none;
    text-shadow: none;
    ${POPUP_SCALE.buttonType}
  }
`;

export const PopupCancel = styled(PopupButton)`
  &&,
  &&:hover,
  &&:focus,
  &&[disabled],
  &&[disabled]:hover {
    border: 1px solid #212d4b;
    background: #15203e;
    color: #f5f7fb;
  }

  &&[disabled] {
    opacity: 0.5;
  }
`;

export const PopupConfirm = styled(PopupButton)`
  &&,
  &&:hover,
  &&:focus {
    border: 1px solid #4f46e5;
    background: #4f46e5;
    color: #ffffff;
    font-weight: 500;
  }
`;
